function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('h1',[_vm._v("Journal of Environmental Protection and Ecology")]),_vm._v(" "),_c('p',[_vm._v("International Journal edited by the Balkan Environmental Association (B.E.N.A.) for rapid scientific and other information, covering all aspects of the problems of sustainable development and ecology.")])])}]

return { render: render, staticRenderFns: staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"href":"/journals/1311-5065","lang":"en","title":"Journal of  Environmental Protection and Ecology","description":"International Journal edited by the Balkan Environmental Association (B.E.N.A.) for rapid scientific and other information, covering all aspects of the problems of sustainable development and ecology.","issn":"1311-5065","image":"/images/cover-1311-5065.jpg","order":2,"restricted":true},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }